/**
 * The following pattern requires:
 * - at least 1 character in lower case;
 */
export const AT_LEAST_ONE_LOWERCASE_CHARACTER_PATTERN = '(?=.*[a-z])';

/**
 * The following pattern requires:
 * - at least 1 character in upper case;
 */
export const AT_LEAST_ONE_UPPERCASE_CHARACTER_PATTERN = '(?=.*[A-Z])';

/**
 * The following pattern requires:
 * - at least 1 digit;
 */
export const AT_LEAST_ONE_DIGIT_PATTERN = '(?=.*[0-9])';

/**
 * The following pattern requires:
 * - at least 1 special character: ~, !, @, #, $, %, ^, &, *, (, ), [, {, }
 */
export const AT_LEAST_ONE_SPECIAL_CHARACTER_PATTERN = '(?=.*[~!@#$%^&*()[{}])';

/**
 * The following pattern requires:
 * - no more than 2 repeating characters in a row (case insensitive) - aaa, bBb, CcC;
 * - no more than 2 consecutive characters (case insensitive) - abc, cba, aBc or CbA;
 * - no more than 2 consecutive digits - 123 or 321;
 * - at least 1 character in lower case;
 * - at least 1 character in upper case;
 * - at least 1 digit;
 * - at least 1 special character: ~, !, @, #, $, %, ^, &, *, (, ), [, {, }
 */
export const PASSWORD_VALIDATION_PATTERN = '^' +
  AT_LEAST_ONE_DIGIT_PATTERN +
  AT_LEAST_ONE_LOWERCASE_CHARACTER_PATTERN +
  AT_LEAST_ONE_UPPERCASE_CHARACTER_PATTERN +
  AT_LEAST_ONE_SPECIAL_CHARACTER_PATTERN +
  '.*$';

/**
 * Following regex covers following invalid phone cases:
 * - non-US country code (US country code: +1, 1, or empty)
 * - too many digits;
 * - prefix code too long;
 * - invalid delimiter between digits;
 * - country code too long;
 * - invalid character;
 * - too many spaces;
 * - invalid delimiter;
 */
export const PHONE_VALIDATION_PATTERN = '^((\\+[1]{1})?|([1]{1})?)[-. ]?\\(?([0-9]{3})\\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$';

/**
 * Accepts only digits and hyphens
 */
export const SSN_VALIDATION_PATTERN = '^[0-9-]*$';

/**
 * Accepts only digits, lowercase letters and uppercase letters
 */
export const ALPHANUMERIC_SYMBOLS_PATTERN = '^[A-Za-z0-9]*$';

/**
 * Accepts only lowercase letters, uppercase letters, spaces, hyphens, and apostrophes
 */
export const NAME_VALIDATION_PATTERN = "^[ A-Za-z'-]*$";